import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { SignError } from '../sign.model';

@Injectable({
    providedIn: 'root'
})
export class ApIcmpErrorService {
    private readonly hadError: boolean;

    private readonly error: BehaviorSubject<SignError> = new BehaviorSubject<SignError>(undefined);

    public static isIcmpError(error: HttpErrorResponse): boolean {
        return !error.status;
    }

    public hasError(): BehaviorSubject<SignError> {
        return this.error;
    }

    public broadcast(hasError: boolean): void {
        if (this.hadError !== hasError) {
            this.error.next(hasError ? { key: 'no-connection', type: 'warning' } : undefined);
        }
    }
}
